import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { PartnerOrganizationManager } from "./entity";

const createCustomFilter = createCustomFilterForEntity<PartnerOrganizationManager>();

export class PartnerOrganizationManagerFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<PartnerOrganizationManager>
  >((filters) => filterWithRelationsAndJson(PartnerOrganizationManager)(filters));
}
